import {CONSTANTS} from '@/constants'

export default function(h, row, index) {
    let _created_d = ''
    let _created_t = ''
    if (row.date_create_iso !== null && row.date_create_iso) {
        _created_d = row.date_create_iso.substring(0,10);
        _created_t = row.date_create_iso.substring(11,16);
    }

    if (row.status_index === CONSTANTS.ORDER_STATUS_NEW) {
        return <span><span class='nobr' title='Заявка оформлена'>C: {_created_d}<sup>{_created_t}</sup></span></span>
    }

    if (row.status_index === CONSTANTS.ORDER_STATUS_TAKEN) {
        let _taken_d = ''
        let _taken_t = ''
        if (row.date_manager_take_iso !== null && row.date_manager_take_iso) {
            _taken_d = row.date_manager_take_iso.substring(0,10);
            _taken_t = row.date_manager_take_iso.substring(11,16);
        }
        return <span><span class='nobr' title='Заявка оформлена'>C: {_created_d}<sup>{_created_t}</sup></span><br/><span class='nobr' title='Принято в работу'>P: {_taken_d}<sup>{_taken_t}</sup></span></span>
    }

    if (row.status_index === CONSTANTS.ORDER_STATUS_POSTPONED) {
        let _sleep_d = ''
        let _sleep_t = ''
        if (row.date_manager_wait_iso !== null && row.date_manager_wait_iso) {
            _sleep_d = row.date_manager_wait_iso.substring(0,10);
            _sleep_t = row.date_manager_wait_iso.substring(11,16);
        }

        let _wakeup_d = ''
        if (row.date_manager_refresher_iso !== null && row.date_manager_refresher_iso) {
            _wakeup_d = row.date_manager_refresher_iso.substring(0,10);
        }

        return <span><span class='nobr' title='Заявка оформлена'>C: {_created_d}<sup>{_created_t}</sup></span><br/><span class='nobr' title='Отправлено в ожидание'>O: {_sleep_d}<sup>{_sleep_t}</sup></span><br/><span class='nobr' title='Возврат в работу'>В: {_wakeup_d}</span></span>
    }

    if (row.status_index === CONSTANTS.ORDER_STATUS_ARCHIVED) {
        let _close_d = ''
        let _close_t = ''
        if (row.date_manager_close_iso !== null && row.date_manager_close_iso) {
            _close_d = row.date_manager_close_iso.substring(0,10);
            _close_t = row.date_manager_close_iso.substring(11,16);
        }

        return <span><span class='nobr' title='Заявка оформлена'>C: {_created_d}<sup>{_created_t}</sup></span><br/><span class='nobr' title='Закрыто'>З: {_close_d}<sup>{_close_t}</sup></span></span>
    }
}